import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from './Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region SUBTOTAL

function _Subtotal(props) { return <LabelValue {...props} value={props.content} /> }
const Subtotal = withLabelTokenParsing(_Subtotal, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Subtotal:
            if (data.ExchangeRate && data.ExchangeRate.Subtotal != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Subtotal, options);
            }
            break;
        case Token.DisplayCurrency.SubtotalLessDiscount:
            if (data.ExchangeRate && data.ExchangeRate.SubtotalLessDiscount != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.SubtotalLessDiscount, options);
            }
            break;
        case Token.Total.Subtotal:
            if (data.Subtotal != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Subtotal, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        case Token.Total.SubtotalLessDiscount:
            if (data.SubtotalLessDiscount != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.SubtotalLessDiscount, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Subtotal', defaultValue, Token.Total.Subtotal),
        Token.getCurrencyTokenConfig('Subtotal (Discount Included)', defaultValue, Token.Total.SubtotalLessDiscount),
        Token.getWrappedTokenConfig('Subtotal (Display Currency)', Token.DisplayCurrency.Subtotal),
        Token.getWrappedTokenConfig('Subtotal (Discount Included - Display Currency)', Token.DisplayCurrency.SubtotalLessDiscount)
    ];
};
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Subtotal' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Subtotal}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Subtotal }))
    }
};

// #endregion SUBTOTAL

export {
    Subtotal as Component,
    Tokens,
    TypeConfig
}